/**
 * Message type enum for case messages.
 */
export enum MessageType {
  /** Public communication with case requester */
  ReplyToRequester = 1,
  /** Automatically generated by the system */
  System = 2,
}

/**
 * DTO for add message request.
 * NOTE: API expects camelCase fields
 */
export interface AddMessageRequestDto {
  messageType: MessageType;
  body: string;
  attachments: AddMessageAttachmentDto[];
}

export interface AddMessageAttachmentDto {
  fileName: string;
  filePath: string;
  fileSizeBytes: number;
  contentType: string;
}
